import { useLocation } from "react-router-dom";
import { useGetCurrentUserQuery } from "../store/user/userApi";
import { SALON_USERNAME } from "../utils/constants/salonEmail";
import { decodeJWT } from "../utils/decodeJWT";
import { readFromStorage } from "../utils/webStorage";

export const GuestGuard = (): boolean => {
  const token = readFromStorage("accessToken");
  if (token) {
    return false;
  } else {
    return true;
  }
};

export const GuestSaloonGuard = (): boolean => {
	const token = readFromStorage("accessToken");
	if (token) {
	  return false;
	} else {
	  return true;
	}
  };

export const AdminGuard = (): boolean => {
  const { data } = useGetCurrentUserQuery();
  const token = readFromStorage("accessToken");
  return token
    ? data?.groups?.length
      ? Boolean(data?.groups.includes("admins"))
      : localStorage.getItem("roles") === "admins"
    : false;
};

export const PartnerAgentGuard = (): boolean => {
  const { data } = useGetCurrentUserQuery();
  const token = readFromStorage("accessToken");
  const decodedToken = decodeJWT(token || '');
  return token
    ? (data?.groups?.length
        ? Boolean(
            data?.groups.includes("partners") || data?.groups.includes("agents")
          )
        : localStorage.getItem("roles") === "partners" ||
          localStorage.getItem("roles") === "agents") 
		&& decodedToken['cognito:username'] !== SALON_USERNAME
    : false;
};

export const SaloonWorldGuard = (): boolean => {
  const { data } = useGetCurrentUserQuery();
  const token = readFromStorage("accessToken");
  const decodedToken = decodeJWT(token || '');
  return token
    ? (data?.groups?.length
        ? Boolean(
            data?.groups.includes("partners") || data?.groups.includes("agents")
          )
        : localStorage.getItem("roles") === "partners" ||
          localStorage.getItem("roles") === "agents") 
		  && decodedToken['cognito:username'] === SALON_USERNAME
    : false;
};

export const PartnerGuard = (): boolean => {
  const { data } = useGetCurrentUserQuery();
  const token = readFromStorage("accessToken");
  return token
    ? data?.groups?.length
      ? Boolean(data?.groups.includes("partners"))
      : localStorage.getItem("roles") === "partners"
    : false;
};

export const SupplierGuard = (): boolean => {
  const { data } = useGetCurrentUserQuery();
  const token = readFromStorage("accessToken");
  return token
    ? data?.groups?.length
      ? Boolean(data?.groups.includes("suppliers"))
      : localStorage.getItem("roles") === "suppliers"
    : false;
};
